export function isHoneypotFilled(values: Record<string, unknown>, fieldName: string): boolean {
  try {
    return String(values[fieldName] ?? '').trim().length > 0;
  } catch {
    return false;
  }
}
